import { render, staticRenderFns } from "./IconUploads.vue?vue&type=template&id=441fc272&"
import script from "./IconUploads.vue?vue&type=script&lang=js&"
export * from "./IconUploads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports